import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { BulkAction } from '../types';

interface BulkActionsProps {
  selectedCount: number;
  bulkActions: BulkAction[];
  onClearSelection?: () => void;
}

export const BulkActions: React.FC<BulkActionsProps> = ({
  selectedCount,
  bulkActions,
  onClearSelection
}) => {
  return (
    <div className="flex items-center gap-2 lg:gap-3 flex-wrap w-full lg:w-auto justify-center lg:justify-start">
      {/* Selection Info */}
      <div className="flex items-center gap-1 lg:gap-2 shrink-0">
        <Badge className="bg-moss-primary/10 text-moss-primary border-moss-primary/20 hover:bg-moss-primary/10">
          <div className="w-1.5 h-1.5 bg-moss-primary rounded-full mr-1.5" />
          {selectedCount} geselecteerd
        </Badge>
        
        {onClearSelection && (
          <Button
            variant="link"
            size="sm"
            onClick={onClearSelection}
            className="text-xs lg:text-sm h-auto p-0"
            title="Deselecteer alle items"
          >
            Deselecteer alles
          </Button>
        )}
      </div>

      {/* Action Buttons */}
      <div className="flex items-center gap-1 lg:gap-2 flex-wrap justify-center lg:justify-start">
        {bulkActions.map((action, index) => {
          // Map legacy variant names to shadcn button variants
          let buttonVariant: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' = 'default';

          if (action.variant === 'red') buttonVariant = 'destructive';
          else if (action.variant === 'secondaryNeutral') buttonVariant = 'secondary';
          else if (action.variant === 'yellow') buttonVariant = 'outline';
          
          return (
            <Button
              key={index}
              variant={buttonVariant}
              size="sm"
              onClick={action.onClick}
              disabled={action.disabled}
              className={cn("text-xs")}
            >
              {action.icon && <span className="mr-1">{action.icon}</span>}
              {action.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
};
